<template>
    <div
            class="row"
    >
    <span
            class="heading"
    >
      Статус проекта: {{ projectLockStatus }}
    </span>

        <q-btn
                v-if="projectIsLocked"
                @click="unlockProject"
                icon="lock_open"
                class="hover-primary q-ml-sm"
                flat
                round
        >
            <q-tooltip
                    :delay="500"
                    :offset="[0, 5]"
            >
                Разблокировать проект
            </q-tooltip>
        </q-btn>

        <q-btn
                v-else
                @click="lockProject"
                icon="lock"
                class="hover-primary q-ml-sm"
                flat
                round
        >
            <q-tooltip
                    :delay="500"
                    :offset="[0, 5]"
            >
                Заблокировать проект
            </q-tooltip>
        </q-btn>

        <q-btn
                @click="deleteLimbCache"
                icon="sync"
                class="hover-primary q-ml-sm"
                :loading="limbCacheIsDeleting"
                flat
                round
        >
            <q-tooltip
                    :delay="500"
                    :offset="[0, 5]"
            >
                Сбросить кэш проекта
            </q-tooltip>
        </q-btn>

        <q-btn
                @click="updateCompanyInfo"
                icon="info"
                class="hover-primary q-ml-sm"
                :loading="updatingCompanyInfo"
                flat
                round
                :disabled="updatingCompanyInfo"
        >
            <q-tooltip
                    :delay="500"
                    :offset="[0, 5]"
            >
                Обновить данные про компанию в Intercom
            </q-tooltip>
        </q-btn>

        <project-lock-status-modal
                :project="project"
                :opened="modalOpened"
                @closed="modalOpened = false"
        />
    </div>
</template>

<script>
import { QBtn, QTooltip } from 'quasar'

import ProjectLockStatusModal from './ProjectLockStatusModal'
import projectLockStatuses from '../../mixins/projectLockStatuses'

export default {
  name: 'ProjectLockStatus',

  props: {
    project: {
      type: Object,
      required: true,
    },
  },

  components: {
    ProjectLockStatusModal,
    QBtn,
    QTooltip,
  },

  data () {
    return {
      modalOpened: false,
      limbCacheIsDeleting: false,
      updatingCompanyInfo: false,
    }
  },

  mixins: [
    projectLockStatuses,
  ],

  methods: {
    unlockProject () {
      this.$store.dispatch('project/unlockProject', this.project).then(() => {
        this.$q.notify({
          message: `Сохранено`,
          type: 'positive',
          position: 'bottom',
        })
      })
    },

    lockProject () {
      this.modalOpened = true
    },

    deleteLimbCache () {
      this.limbCacheIsDeleting = true

      this.$store.dispatch('project/deleteLimbCache', this.project).then(() => {
        this.$q.notify({
          message: `Запрос на сброс кэша успешно отправлен`,
          type: 'positive',
          position: 'bottom',
        })

        this.limbCacheIsDeleting = false
      }).catch(e => {
        this.$q.notify({
          message: `${ e.message }`,
          type: 'negative',
          position: 'bottom',
        })

        this.limbCacheIsDeleting = false
      })
    },

    updateCompanyInfo () {
      this.updatingCompanyInfo = true

      this.$store.dispatch('project/updateCompanyInfo', this.project).then(() => {
        this.$q.notify({
          message: `Запрос на обновление информации поставлен в очередь`,
          type: 'positive',
          position: 'bottom',
        })
      }).catch(e => {
        this.$q.notify({
          message: `${ e.message }`,
          type: 'negative',
          position: 'bottom',
        })
      }).finally(() => {
        this.updatingCompanyInfo = false
      })
    },
  },

  computed: {
    projectIsLocked () {
      return !this.project.lock_status.includes('UNLOCKED')
    },

    projectLockStatus () {
      return this.statuses[this.project.lock_status]
             ? this.statuses[this.project.lock_status]
             : this.project.lock_status
    },
  },
}
</script>

<style scoped>
.heading {
    padding-top: 12px;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/ProjectLockStatus/ProjectLockStatus.vue